import { render } from "./ViewCollectedData.vue?vue&type=template&id=30c152aa&scoped=true"
import script from "./ViewCollectedData.vue?vue&type=script&lang=js"
export * from "./ViewCollectedData.vue?vue&type=script&lang=js"

import "./ViewCollectedData.vue?vue&type=style&index=0&id=30c152aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c152aa"]])

export default __exports__